import { render, staticRenderFns } from "./singlecourse.vue?vue&type=template&id=40537f76&scoped=true&"
import script from "./singlecourse.vue?vue&type=script&lang=js&"
export * from "./singlecourse.vue?vue&type=script&lang=js&"
import style0 from "./singlecourse.vue?vue&type=style&index=0&id=40537f76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40537f76",
  null
  
)

export default component.exports